export default function BasicDetailsStep({ data, setData }) {

    const handleChange = (e) => {
        const { name, value } = e.target;

        setData({
            ...data,
            [name]: value
        });
    };

    return (
        <div>
            <h2 className="h4 fw-semibold text-dark mb-0 px-0 py-4">
                Enter Basic Details
            </h2>

            <div className="border shadow-sm rounded rounded-5 pb-4">

                {/* Personal Info */}
                <div className="card-body p-4">
                    <h5 className="fw-semibold text-secondary mb-3">Personal Information</h5>

                    <div className="row g-3 mb-3">
                        <div className="col-md-6">
                            <label className="form-label">Full Name *</label>
                            <input
                                type="text"
                                name="full_name"
                                value={data.full_name || ""}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Enter full name"
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label">Mobile Number *</label>
                            <input
                                type="tel"
                                name="mobile"
                                value={data.mobile || ""}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="+91 XXXXXXXXXX"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="form-label">Email *</label>
                        <input
                            type="email"
                            name="email"
                            value={data.email || ""}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Enter email"
                        />
                    </div>
                </div>

                <hr />

                {/* Contact Details */}
                <div className="card-body p-4">
                    <h5 className="fw-semibold text-secondary mb-3">Contact Details</h5>

                    <div className="mb-3">
                        <label className="form-label">Contact Person Name *</label>
                        <input
                            type="text"
                            name="contact_person"
                            value={data.contact_person || ""}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>

                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label">Contact Mobile *</label>
                            <input
                                type="tel"
                                name="contact_mobile"
                                value={data.contact_mobile || ""}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label">Contact Email *</label>
                            <input
                                type="email"
                                name="contact_email"
                                value={data.contact_email || ""}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
